/**
 * One entry on a wizard's spine, as the rail draws it. Where a wizard keeps
 * its steps — and what "done" means for each — is the wizard's business; the
 * rail only asks these questions of a step against the wizard's own state.
 *
 * Three kinds of entry, told apart by shape:
 * - a numbered step (`railNumber`),
 * - an indented sub-step (`subStepOf`),
 * - the one flag entry at the bottom (neither): the wizard's close.
 */
export interface RailStep<Id extends string = string, State = unknown> {
  id: Id;
  /** 1-based number on the spine; absent with no `subStepOf` = the flag entry */
  railNumber?: number;
  /** Rendered indented under this step */
  subStepOf?: Id;
  label: string;
  /** Short sub-line under the label */
  description?: string;
  isDone?(state: State): boolean;
  isReachable(state: State): boolean;
  /** Hidden from the rail entirely when false; defaults to visible */
  isVisible?(state: State): boolean;
}

export const isFlagStep = (step: RailStep) =>
  step.railNumber === undefined && step.subStepOf === undefined;
